import axios from "axios";
import { authorizedHeader } from "./authorization";
import {
  imeiListApiUrl,
  vehicleDetailsApiUrl,
  vehicleCurrentStatusApiUrl,
} from "components/Common/endpoints";

export const getImeiList = async () => {
  const response = await axios({
    method: "GET",
    url: imeiListApiUrl,
    params: null,
    headers: authorizedHeader(),
  });
  return response?.data;
};

export const getVehicleDetails = async (vIdVal) => {
  const response = await axios({
    method: "GET",
    url: vehicleDetailsApiUrl,
    params: { vIdVal },
    headers: authorizedHeader(),
  });
  return response?.data;
};

export const getVehicleCurrentStatus = async (vIdVal) => {
  const response = await axios({
    method: "GET",
    url: vehicleCurrentStatusApiUrl,
    params: { vIdVal },
    headers: authorizedHeader(),
  });
  return response?.data;
};
